import { Filters, FiltersLayout, List, ListPageLayout, SearchInput } from 'framework/list';
import DocumentTypeFilter from './filter/DocumentTypeFilter';
import ReportSecurityIncidentButton from './button/ReportSecurityIncidentButton';
import useEmployeeComplianceRegistryService from 'domain/people/employee/compliance/useEmployeeComplianceRegistryService';
import { ComplianceDocumentContext } from 'domain/shared/compliance';
import { PORTAL_COMPLIANCE_REGISTRY_ALL_ITEMS_PAGE_SIZE } from 'domain/shared/employee';
import GroupedPortalComplianceGrid from './GroupedPortalComplianceGrid';

const EmployeePortalCompliance = () => {
  const { searchPortalCompliance } = useEmployeeComplianceRegistryService();

  const filters = (
    <Filters>
      <FiltersLayout>
        <DocumentTypeFilter source="complianceType" label="Type" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <ComplianceDocumentContext>
      <List getDataMethod={searchPortalCompliance} pageSize={PORTAL_COMPLIANCE_REGISTRY_ALL_ITEMS_PAGE_SIZE}>
        <ListPageLayout
          filter={filters}
          search={<SearchInput label="document name" />}
          actions={[<ReportSecurityIncidentButton key="report-security-incident" />]}
          sxPaper={{ p: '0 !important', backgroundColor: 'inherit' }}
        >
          <GroupedPortalComplianceGrid />
        </ListPageLayout>
      </List>
    </ComplianceDocumentContext>
  );
};

export default EmployeePortalCompliance;
